var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-email-2152688 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.979349 3.6065C1.15829 3.32019 1.4068 3.08384 1.70173 2.91947C1.99665 2.75511 2.32839 2.66808 2.66602 2.6665H13.3327C13.6703 2.66808 14.002 2.75511 14.297 2.91947C14.5919 3.08384 14.8404 3.32019 15.0193 3.6065L7.99935 8.51984L0.979349 3.6065ZM15.3327 5.01317L10.7327 8.23317L15.1327 12.1865C15.2638 11.9211 15.3322 11.6292 15.3327 11.3332V5.01317ZM0.666016 5.01317V11.3332C0.666478 11.6292 0.734903 11.9211 0.866016 12.1865L5.26602 8.23317L0.666016 5.01317ZM9.61268 9.01317L8.37935 9.87317C8.26775 9.95059 8.13517 9.99207 7.99935 9.99207C7.86353 9.99207 7.73095 9.95059 7.61935 9.87317L6.38602 9.01984L1.81268 13.1332C2.07807 13.2643 2.37001 13.3327 2.66602 13.3332H13.3327C13.6307 13.3314 13.9245 13.2631 14.1927 13.1332L9.61268 9.01317Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEmail);
export default __webpack_public_path__ + "static/media/footer-email.d90d69d21137e5e78ebe9a98ba91993f.svg";
export { ForwardRef as ReactComponent };